/* eslint-disable jsx-a11y/anchor-is-valid */
import { formatDate } from "../../../utils/helpers";
import { useState, useEffect } from 'react';
import "../../../pages/main/AvailablesCourses.css"



function NextSessionSection({ currentSession, closedSessions, allCourses, mostRecentCourse }) {
  console.log('close', allCourses)
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const showCoursePage = process.env.REACT_APP_SHOW_COURSE_PAGE === 'true';

  function getTopThreeCourses(allCourses) {
    // Vérifie s'il existe des cours et retourne le premier maximum de trois cours
    return allCourses.slice(0, 3);
  }
  const topCourses = getTopThreeCourses(allCourses);
  const hasAvailableCourses = showCoursePage && topCourses.length > 0;

  // const truncateTitle = (title) => {
  //   if (windowWidth >= 990 && windowWidth <= 1500) {
  //     return title.length > 20 ? title.slice(0, 20) + '...' : title;
  //   } else if (title.length > 40) {
  //     return title.slice(0, 40) + '...';
  //   }
  //   return title;
  // };

  const truncateTitle = (text, fontSize, lineHeight) => {
    // Créer un élément pour mesurer le texte
    const testElement = document.createElement('span');
    testElement.style.visibility = 'hidden';
    testElement.style.whiteSpace = 'normal';
    testElement.style.fontSize = fontSize;
    testElement.style.lineHeight = lineHeight;
    document.body.appendChild(testElement);

    // Obtenir la largeur de l'écran
    const screenWidth = window.innerWidth;
    // Déterminer le nombre de mots ou de caractères à tronquer selon la largeur de l'écran
    let maxLength;
    if (screenWidth <= 490 && screenWidth <= 490) {
      maxLength = 25; // 20 caractères
    } else if (screenWidth >= 490 && screenWidth < 600) {
      maxLength = 70; // 26 caractères
    } else if (screenWidth >= 990 && screenWidth < 1118) {
      maxLength = 22; // 26 caractères
    } else if (screenWidth >= 1119 && screenWidth < 1250) {
      maxLength = 27; // 26 caractères
    } else if (screenWidth >= 1250 && screenWidth < 1300) {
      maxLength = 33; // 26 caractères
    } else if (screenWidth >= 1300 && screenWidth < 1500) {
      maxLength = 42; // 30 caractères
    } else if (screenWidth >= 1500 && screenWidth < 1670) {
      maxLength = 47; // 60 caractères
    } else if (screenWidth > 1670) {
      maxLength = 52; // 80 caractères
    } else {
      maxLength = text.length; // Pas de troncature
    }

    // Définir une variable pour le texte tronqué
    let truncatedText = text;

    // Boucle pour vérifier si le texte dépasse la longueur définie
    if (truncatedText.length > maxLength) {
      truncatedText = truncatedText.slice(0, maxLength) + '...'; // Tronquer et ajouter des points de suspension
    }

    document.body.removeChild(testElement); // Nettoyer l'élément de test
    return truncatedText; // Retourner le texte tronqué ou non
  };

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);

    // Supprimez l'écouteur lors du démontage du composant
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  return (
    <>
      <div className="edu-blog-area blog-area-3 edu-section-gap sales-coach-blog">
        <div className="container">
          <ul className="blog-section-title">
            <li>
              <div
                className="section-title section-left sal-animate"
                data-sal-delay="150"
                data-sal="slide-up"
                data-sal-duration="800"
              >
                <span className="pre-title">Next Session</span>
                <h2 className="title">Access Our new Session</h2>
                <span className="shape-line">
                  <i className="icon-19"></i>
                </span>
              </div>
            </li>
          </ul>
          <div className="row g-5">
            {currentSession && (
              <div
                className="col-lg-6"
                data-sal-delay="100"
                data-sal="slide-up"
                data-sal-duration="800"
              >
                <div className="edu-blog blog-style-2 blog-style-10">
                  <div className="inner">
                    <div className="thumbnail">
                      <a
                        href={`/sessions/next/${currentSession?.slug}-${currentSession?.id}`}
                      >
                        <img
                          style={{
                            height: "370px",
                          }}
                          className="object-cover "
                          src={currentSession?.coverPicture}
                          alt={currentSession?.coverPicture}
                        />
                      </a>
                    </div>
                    <div className="content">
                      <h5 className="pt-5 title">
                        <a
                          href={`/sessions/next/${currentSession?.slug}-${currentSession?.id}`}
                        >
                          {currentSession?.title}
                        </a>
                      </h5>

                      <div className="mt-3 category-wrap">
                        <a
                          href={`/sessions/next/${currentSession?.slug}-${currentSession?.id}`}
                          className="blog-category"
                        >
                          Enroll Now
                        </a>
                      </div>

                      <ul className="mt-4 blog-meta">
                        <li>
                          <i className="icon-27"></i>
                          {`Start Date : ` +
                            formatDate(currentSession?.startDate, 2)}
                        </li>
                        <li>
                          <i className="icon-27"></i>
                          {`End Date : ` +
                            formatDate(currentSession?.endDate, 2)}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {closedSessions && closedSessions.length !== 0
              ? closedSessions?.map((session__) => {
                const isOpenedSession = session__?.status === "OPENED";
                const sessionLink = `/sessions/next/${session__?.slug}-${session__?.id}`;

                return (
                <div
                  key={session__?.id}
                  className="col-lg-3"
                  data-sal-delay="100"
                  data-sal="slide-up"
                  data-sal-duration="800"
                >
                  <div className="edu-blog blog-style-2 blog-style-10">
                    <div className="inner">
                      <div className="thumbnail">
                        {isOpenedSession ? (
                          <a href={sessionLink}>
                            <img
                              src={session__?.coverPicture}
                              alt={session__?.coverPicture}
                            />
                          </a>
                        ) : (
                          <img
                            src={session__?.coverPicture}
                            alt={session__?.coverPicture}
                          />
                        )}
                      </div>
                      <div className="content">
                        <div className="category-wrap">
                          <a
                            href={isOpenedSession ? sessionLink : undefined}
                            className={`blog-category small-category session-block session-block-${isOpenedSession ? "opened" : "closed"}`}
                          >
                            {isOpenedSession ? "Opened" : "Closed"}
                          </a>
                        </div>
                        <h5 className="title">
                          <a
                            href={isOpenedSession ? sessionLink : undefined}
                          >
                            {session__?.title}
                          </a>
                        </h5>
                        <ul className="blog-meta">
                          <li>
                            <i className="icon-27"></i>
                            {`Start Date : ` +
                              formatDate(session__?.startDate, 2)}
                          </li>
                          <li>
                            <i className="icon-27"></i>
                            {`End Date : ` +
                              formatDate(session__?.endDate, 2)}
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              )})
              : null}
          </div>
          {hasAvailableCourses ? (
            <>
              <br></br>
              <ul className="blog-section-title">
                <li>
                  <ul className="blog-section-title">
                    <li>
                      <div
                        className="section-title section-left sal-animate"
                        data-sal-delay="150"
                        data-sal="slide-up"
                        data-sal-duration="800"
                      >
                        <span className="pre-title">Available courses</span>
                        <h2 className="title">Explore Our Latest Courses</h2>

                        <span className="shape-line">
                          <i className="icon-19"></i>
                        </span>
                      </div>
                    </li>
                  </ul>
                </li>
              </ul>
              <div>
                <div className="container edublink-animated-shape">
                  <div className="col-lg-12">
                    <div className="row">
                      {topCourses.map((course) => (
                        <div key={course.id} className="col-lg-4 ">
                          <div className={`edu-course course-style-7 bg-color-primary`}>
                            <div className="inner">
                              <div className="thumbnail">
                                <a href={`/courses/next/${course.slug}-${course.id}`}>
                                  <img
                                    style={{ height: "250px" }}
                                    className="object-cover"
                                    src={course?.coverPicture}
                                    alt={course?.title} />
                                </a>
                                <div
                                  className="course-price price-round"
                                  style={{
                                    fontSize: '17px',
                                    padding: '5px 10px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    borderRadius: '4px',
                                    height: '40px',
                                    color: '#1E4E70',
                                    backgroundColor: 'white',
                                    marginBottom: '63px',
                                    width: '100px',
                                    minWidth: '80px',
                                    textAlign: 'center',
                                  }}
                                >
                                  ${course?.price}
                                </div>
                              </div>
                              <div className="content mt-1" style={{ backgroundColor: '#FFFFFF' }}>
                                <span className="course-level" style={{ color: 'rgba(61, 59, 59, 0.7)' }}>
                                  <i className="icon-59" style={{ marginRight: '8px', color: '#1E4E70' }}></i>
                                  English language
                                </span>
                                <h5 className="course-rating" style={{ fontSize: '18px', fontWeight: 'bold', color: '#0c0c0cff', minHeight: '50px' }}>
                                  <a href={`/courses/next/${course?.slug}-${course?.id}`}>
                                    {truncateTitle(course?.title)}
                                  </a>
                                </h5>
                                <li className="course-rating mt-3" style={{ color: 'rgba(61, 59, 59, 0.7)' }}>
                                  <i className="icon-7" style={{ marginRight: '8px', color: '#1E4E70' }}></i>
                                  Lessons: &nbsp; <span style={{ color: 'rgba(61, 59, 59, 0.7)' }}>
                                    {course?.numberLessons}
                                  </span>
                                </li>
                                <div className="mt-3" style={{ display: 'flex', justifyContent: 'center', marginBottom: "15px" }}>
                                  <a
                                    className="edu-btn btn-medium curved-medium"
                                    href={`/courses/next/${course.slug}-${course.id}`}
                                    style={{
                                      color: 'white',
                                      width: '100%',
                                      padding: '20px',
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      textDecoration: 'none',
                                      marginTop: '12px'
                                    }}>
                                    LEARN MORE <i className="icon-4"></i>
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </>
          ) : null}
        </div>

      </div>


    </>
  );
}

export default NextSessionSection;
